import Vue from 'vue';
import {UserRoleEnum} from '@/enums/userRolesEnum';
import PastPayments from './cards/pastPayments/PastPayments';
import UpcomingPayments from './cards/upcoming/UpcomingPayments';
import PastYears from './cards/pastYears/PastYears';

export default Vue.extend({
  name: 'Payments',
  components: {
    PastPayments,
    UpcomingPayments,
    PastYears
  },
  data () {
    return {
      isAuthorized: false,
    };
  },
  computed: {
    providerId (): number {
      return this.$store.state.user.providerId;
    }
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole']([ UserRoleEnum.PROVIDER ]);
  },
  methods: {
  }
});



// WEBPACK FOOTER //
// ./src/components/payments/Payments.ts